'use strict';

var collection = require('../internals/collection');

var collectionStrong = require('../internals/collection-strong'); // `Set` constructor
// https://tc39.github.io/ecma262/#sec-set-objects


module.exports = collection('Set', function (get) {
  return function Set() {
    return get(this, arguments.length ? arguments[0] : undefined);
  };
}, collectionStrong);